/* tslint:disable */

/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum UIWidgetEnum {
	Text = 'text',
	Textarea = 'textarea',
	Select = 'select',
}

export function UIWidgetEnumFromJSON(json: any): UIWidgetEnum {
	return UIWidgetEnumFromJSONTyped(json, false);
}

export function UIWidgetEnumFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): UIWidgetEnum {
	return json as UIWidgetEnum;
}

export function UIWidgetEnumToJSON(value?: UIWidgetEnum | null): any {
	return value as any;
}
